import React from "react";
import { ForgetPasswordCompleteContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { withTranslation } from "react-i18next";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Buttons } from "components";

class ForgetPasswordCompleteContainer extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <ForgetPasswordCompleteContainerStyled>
        <div className="title">
          {t("Verification link has been sent", { ns: "register" })}
        </div>
        <div className="sub_title">
          {t(
            "The verification link has been sent to the email address or phone number associated with your account. If you don't see the email, make sure to check your spam folder.",
            { ns: "register" },
          )}
        </div>
        <div className="btn_wrap">
          <Buttons.BgStandard
            label={t("Done", { ns: "register" })}
            onClick={() => this.props.router.navigate(ROUTE_PATH.LOGIN)}
          />
        </div>
      </ForgetPasswordCompleteContainerStyled>
    );
  }
}

export default withTranslation(["common", "register"])(
  withRouter(ForgetPasswordCompleteContainer),
);
